import { ChangeEvent } from 'react'

import { Textarea } from '@dc-shared-web/components/shadcn'
import { AIConfigModalValues } from '@dc-shared-web/components/features/AIConfigDialog/types'

const SystemPromptRow = ({
  values,
  disabled,
  onChange,
}: {
  values: AIConfigModalValues
  disabled?: boolean
  onChange: (values: AIConfigModalValues) => void
}) => {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange({ ...values, systemPrompt: e.target.value })
  }

  return (
    <div className='tw-flex tw-flex-col tw-gap-1'>
      <p className='tw-text-sm'>System prompt (persona)</p>
      <Textarea
        rows={4}
        value={values.systemPrompt}
        onChange={handleChange}
        disabled={disabled}
        autoFocus
        placeholder='Enter system prompt...'
      />
    </div>
  )
}

export default SystemPromptRow
